export default function isValidCanadianZipCode(zip: string) {
  if (!zip) {
    return false;
  }
  if (
    zip.toLowerCase().includes('xxx') ||
    zip.includes('---') ||
    zip.length < 6
  ) {
    return false;
  }
  return true;
}
